import React from 'react';

const ProgressTracker = ({ progress, totalDuration }) => {
    return (
        <div className="progress-tracker">
            <div className="progress-bar">
                <div 
                    className="progress-fill"
                    style={{ width: `${progress}%` }}
                />
            </div>
            <div className="progress-stats">
                <span>{progress}% Complete</span>
                <span>{totalDuration} Total</span>
            </div>
        </div>
    );
};

export default ProgressTracker;